<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.measurementsUnits')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div style="display: flex;">
      <div class="card mar-to-15" style="width: calc(100% - 20px); margin-left: 10px; margin-right: 10px;">
        <div class="card-content">
          <div class="text-right">
            <p class="">
              <button class="btn add"  @click.prevent="goToAdd" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
                <img src="/static/img/icons/add.png">
                {{$t('general.add')}}
              </button>
            </p>
          </div>
          <data-tables
                v-loading="loading"
                :data="tableData"
                ref="userList"
                :search-def="{}"
                :pagination-def="{}"
                :table-props="{'border': false}"
                @row-click="goToRecord"
                style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                            :key="column.label"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            sortable>
            </el-table-column>
            <el-table-column
                  :width="150">
              <template slot-scope="props">
                <div class="edit">
                  <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Option, Pagination} from 'element-ui'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import DataTables from 'vue-data-tables'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  export default {
    components: {
      PPagination,
      // GeneralTopBar,
      [Input.name]: Input
    },
    props: {
      callback: {
        required: false
      },
      callbackAdd: {
        required: false
      },
      isTable: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.token = this.$session.get('token')
      this.getData()
    },
    data () {
      return {
        loading: true,
        token: null,
        apiUrl: null,
        tableColumns: [
          {
            prop: 'id',
            label: 'ID',
            minWidth: 100
          },
          {
            prop: 'name',
            label: this.$t('settingTable.name'),
            minWidth: 300
          }
        ],
        tableData: []
      }
    },
    methods: {
      goToRecord (row, event, column) {
        if (typeof this.callback === 'function') {
          this.callback(row.id)
        } else {
          this.globalGoToRecord(row, event, column, '/user/edit/')
        }
      },
      getData () {
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/measurements-units', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      goToAdd () {
        if (typeof this.callback === 'function') {
          this.callback(null)
        }
      }
    }
  }
</script>
<style>
  .copy_link {
    width: 100%;
  }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/MeasurementsUnits/MeasurementsUnits.vue